import React, { useCallback, useEffect, useState } from 'react';
import {t} from '@lingui/macro';
import {Input} from "antd";
import {isValidHex} from "react-color/lib/helpers/color";

export const HexInput = React.forwardRef((props, ref) => {
    const { value, onChange } = props;

    const [_value, _setValue] = useState(value);

    useEffect(() => {
        _setValue(value);
    }, [value, _setValue]);

    const handleChange = useCallback(e => {
        const hexCode = e.target.value;
        _setValue(hexCode);

        if (isValidHex(hexCode))
            onChange(`#${hexCode.replace("#", '')}`);
    }, [onChange]);

    const handleBlur = useCallback(hexCode => {
        if (isValidHex(hexCode))
            onChange(`#${hexCode.replace("#", '')}`);
        else
            _setValue(value);
    }, [onChange, value]);

    return <Input
        addonBefore={t`Hex`}
        ref={ref}
        prefix="#"
        placeholder="ffffff"
        value={_value ? _value.replace("#", '') : _value}
        onChange={handleChange}
        onBlur={handleBlur}
    />;
});
